import { useEffect, useState } from 'react'

export default function CheckUserAdmin(roles, orgId) {
  const [first, setFirst] = useState()
  useEffect(() => {
    if (roles && orgId) {
      const newFirst = roles.find((d) => d.org_id.toString() === orgId.toString())
      setFirst(newFirst)
    }
  }, [roles, orgId])

  return first
}
